import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";

const DetailsPage = () => {
  const [details, setDetails] = useState([]);
  const { name } = useParams();

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const res = await fetch(`https://restcountries.com/v3.1/name/${name}`);
        const data = await res.json();
        setDetails(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchDetails();
  }, [name]);

  return (
    <div className="container flex justify-center items-center min-h-screen p-6 bg-gray-100 dark:bg-gray-900">
      <section className="p-8 max-w-5xl w-full bg-white shadow-lg rounded-lg dark:bg-gray-800">
        {details.map((item) => (
          <div
            key={item.population}
            className="grid grid-cols-1 gap-8 md:grid-cols-2 md:items-center"
          >
            {/* Flag Section */}
            <article className="flex justify-center">
              <img
                className="rounded-lg shadow-md w-full max-w-md"
                src={item.flags.svg}
                alt={item.name.common}
              />
            </article>

            {/* Details Section */}
            <article>
              <h1 className="mb-6 font-extrabold text-gray-900 dark:text-white text-4xl lg:text-5xl">
                {item.name.official}
              </h1>
              <ul className="my-4 space-y-2 text-gray-700 dark:text-gray-300">
                <li>
                  <strong>Capital:</strong> {item.capital[0]}
                </li>
                <li>
                  <strong>Population:</strong> {item.population.toLocaleString()}
                </li>
                <li>
                  <strong>Region:</strong> {item.region}
                </li>
                <li>
                  <strong>Subregion:</strong> {item.subregion}
                </li>
              </ul>

              {/* Borders Section */}
              {item.borders && (
                <div className="mt-6">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                    Borders:
                  </h3>
                  <ul className="flex flex-wrap gap-2">
                    {item.borders.map((border, index) => (
                      <li
                        key={index}
                        className="bg-gray-200 py-1 px-3 rounded text-sm font-medium text-gray-700 dark:bg-gray-700 dark:text-gray-300"
                      >
                        {border}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Back Button */}
              <Link
                to="/"
                className="inline-block mt-8 bg-blue-600 text-white py-2 px-6 rounded shadow hover:bg-blue-700 transition-all duration-200 dark:bg-blue-500 dark:hover:bg-blue-600"
              >
                &larr; Back
              </Link>
            </article>
          </div>
        ))}
      </section>
    </div>
  );
};

export default DetailsPage;
